/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Translation_Merge_Source_Group_LabelInputs */

const en_translation_merge_source_group_label = /** @type {(inputs: Translation_Merge_Source_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Source Group`)
};

const fr_translation_merge_source_group_label = /** @type {(inputs: Translation_Merge_Source_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Groupe source`)
};

const de_translation_merge_source_group_label = /** @type {(inputs: Translation_Merge_Source_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quellengruppe`)
};

const it_translation_merge_source_group_label = /** @type {(inputs: Translation_Merge_Source_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gruppo di origine`)
};

const ru_translation_merge_source_group_label = /** @type {(inputs: Translation_Merge_Source_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Группа источников`)
};

const es_translation_merge_source_group_label = /** @type {(inputs: Translation_Merge_Source_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grupo fuente`)
};

const zh_cn2_translation_merge_source_group_label = /** @type {(inputs: Translation_Merge_Source_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`来源组`)
};

const ja_translation_merge_source_group_label = /** @type {(inputs: Translation_Merge_Source_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ソースグループ`)
};

const hi_translation_merge_source_group_label = /** @type {(inputs: Translation_Merge_Source_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्रोत समूह`)
};

const pt_pt2_translation_merge_source_group_label = /** @type {(inputs: Translation_Merge_Source_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grupo de origem`)
};

/**
* | output |
* | --- |
* | "Source Group" |
*
* @param {Translation_Merge_Source_Group_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const translation_merge_source_group_label = /** @type {((inputs?: Translation_Merge_Source_Group_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Translation_Merge_Source_Group_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_translation_merge_source_group_label(inputs)
	if (locale === "de") return de_translation_merge_source_group_label(inputs)
	if (locale === "it") return it_translation_merge_source_group_label(inputs)
	if (locale === "ru") return ru_translation_merge_source_group_label(inputs)
	if (locale === "es") return es_translation_merge_source_group_label(inputs)
	if (locale === "zh-CN") return zh_cn2_translation_merge_source_group_label(inputs)
	if (locale === "ja") return ja_translation_merge_source_group_label(inputs)
	if (locale === "hi") return hi_translation_merge_source_group_label(inputs)
	if (locale === "pt-PT") return pt_pt2_translation_merge_source_group_label(inputs)
	return en_translation_merge_source_group_label(inputs)
});